import React from "react";

interface Iinitiative {
  title: string;
  description: string;
}

const Impact: React.FC = () => {
  const initiatives: Iinitiative[] = [
    {
      title: "Empowering Individuals",
      description:
        "Providing job-ready skills to unlock new career opportunities.",
    },
    {
      title: "Strengthening Communities",
      description:
        "Enhancing livelihoods through vocational and entrepreneurial training.",
    },
    {
      title: "Driving Economic Growth",
      description: "Building a skilled workforce to meet industry demands.",
    },
    {
      title: "Fostering Inclusion",
      description:
        "Reaching underprivileged and minority communities to ensure equal opportunities.",
    },
  ];

  return (
    <div className="w-full flex justify-center items-center">
      <div className="flex flex-col w-full">
        <div className="max-w-5xl">
          <h4 className=" text-2xl md:text-3xl text-[#2A3342] pt-5 w-full max-w-5xl lg:text-4xl xl:text-[2.9rem]">
            Transforming Lives, Shaping Futures
          </h4>
          <div className="font-medium text-sm pt-2 text-[#182152] lg:pt-4 xl:pt-6 lg:text-base xl:text-[1.5rem]">
            Impact at Scale
          </div>
          <p className="font-light pt-2 max-w-[52rem] lg:text-lg xl:text-2xl lg:pt-4 xl:pt-6 text-[#556987]">
            With a proven track record of upskilling and empowering million
            candidates, we are committed to creating meaningful opportunities
            for individuals and communities alike.
          </p>
        </div>
        <div className="flex w-full justify-center lg:justify-normal pt-10">
          <div className="grid gap-5 md:grid-cols-3 w-full">
            <div className="grid md:grid-cols-2 md:col-span-3 gap-5">
              {initiatives.map((initiative, index) => {
                return (
                  <div
                    key={initiative.title}
                    className="flex flex-col gap-2 py-5"
                  >
                    <div className="flex w-full justify-center items-center">
                      <h5 className="font-normal text-center lg:text-lg w-full max-w-xs xl:text-2xl">
                        {initiative.title}
                      </h5>
                    </div>
                    <div className="flex justify-center items-center w-full">
                      <p className="text-[#556987] lg:text-base text-xs text-center max-w-xs">
                        {initiative.description}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
            {/* <div className="w-full flex justify-center items-center relative h-full">
              <img
                src="/skill/1-2m.png"
                alt="Base workspace"
                className="w-56 md:w-96 lg:w-[34rem] lg:pb-20 xl:w-[36  rem] relative"
              />
              <img
                src="/skill/work.png"
                alt="Overlapping workspace"
                className="absolute w-72 top-8 xl:h-96 -right-4 xl:-right-16 md:top-3 md:-right-8 lg:-right-12 lg:-top-16 xl:-top-[14rem] md:max-w-sm flex"
              />
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Impact;
